<template>
    <div id="app">
        <main-header nowtab="bbs"></main-header>
        <main class="adjuster">
            <a-page-header
                style="border: 1px solid rgb(235, 237, 240)"
                @back="back()"
            >
                <span slot="title" class="thread-title">
                    <span>{{ thread.title }}</span>
                    <a-tag color="#2db7f5" v-if="thread.top    > 0">置顶<a-icon type="pushpin"/></a-tag>
                    <a-tag color="#2db7f5" v-if="thread.star   > 0">精品<a-icon type="star"   /></a-tag>
                    <a-tag color="#BDBDBD" v-if="thread.locked > 0">锁定<a-icon type="lock"   /></a-tag>
                </span>
                <template slot="extra">
                    <a-button @click="triggerHostonly()">
                        {{ hostonly ? '浏览全部' : '只看楼主' }} 
                    </a-button>
                </template>
            </a-page-header>
            <a-pagination :current="Number(pagenow)" :total="total" class="top-pager"
                :defaultPageSize="10" @change="turnPage" :hideOnSinglePage="true"
            />
            <a-divider></a-divider>
            <a-list
                class="thread-list"
                item-layout="horizontal"
                :data-source="data"
            >
                <a-list-item slot="renderItem" slot-scope="post" :id="`p${ post.fid }`">
                    <Post :post="post" @edit="openEditDialog"></Post>
                </a-list-item>
            </a-list>
            <a-divider></a-divider>
            <a-pagination :current="Number(pagenow)" :total="total" 
                :defaultPageSize="10" @change="turnPage" :hideOnSinglePage="true"
            />
            <div v-show="hasLogin" id="editor">
                <wang-editor v-model="postData"></wang-editor>
                <a-button type="primary" id="reply" :loading="posting" @click="doReply">回复</a-button>
            </div>
            <a-result v-show="!hasLogin" title="尚未登录，请登录后回复">
                <template #icon></template>
                <template #extra>
                <a-button type="primary">
                    <a href="/user/login.html">登录</a>
                </a-button>
                </template>
            </a-result>
            <a-modal
                :title="`编辑帖子 - ${editPost.fid}楼`"
                :visible="editorVisible"
                :confirm-loading="editing"
                @ok="doEdit"
                @cancel="() => editorVisible = false"
                :okCancel="false"
                width="95%" :maskClosable="false"
            >
                <wang-editor ref="edit" v-model="editData"></wang-editor>
            </a-modal>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import UserLink from '@/components/UserLink.vue';
import Footer from '@/components/Footer'
import WangEditor from '@/components/WangEditor'
import Post from './Post.vue'
import axios from 'axios';
import { mapState } from 'vuex';
import { createFormData, getReason, getSSRdata } from '../../utils/utils';

const handle = window.matchMedia('(max-width: 599px)');

export default {
    data: () => ({
        data: [],
        thread: {},
        pagenow: 0,
        total: 0,
        hostonly: false,
        postData: "",
        posting: false,
        editorVisible: false,
        editData: "",
        editing: false,
        editPost: {},
        mobile: handle.matches,
        manageItems: [
            { key: 'star',    text: [ '设为精品', '取消加精' ] },
            { key: 'top',     text: [ '设为置顶', '取消置顶' ] },
            { key: 'locked',  text: [ '锁定帖子', '取消锁定' ] },
        ]
    }),
    computed: {
        ...mapState({ hasLogin: 'hasLogin' }),
    },
    provide() {
        return {
            app: this
        }
    },
    async created() {
        handle.onchange = (e) => this.mobile = e.matches;
        const {
            thread, page, hostonly, list, total
        } = getSSRdata("thread");
        this.thread = thread;
        this.pagenow = page;
        this.hostonly = hostonly;
        this.data = list;
        this.total = total;
        document.title = thread.title + " - H5魔塔广场";
    },
    methods: {
        back() {
            window.location.assign("/bbs");
        },
        genSearchParam() {
            const base = `?tid=${this.thread.id}&p=${this.pagenow}`;
            if (this.hostonly) {
                return base + '&hostonly=1';
            } else {
                return base;
            }
        },
        turnPage(page) {
            this.pagenow = page;
            window.location.search = this.genSearchParam();
        },
        triggerHostonly() {
            this.hostonly = !this.hostonly;
            window.location.search = this.genSearchParam();
        },
        async doReply() {
            let content = this.postData;
            content = content.replace(/&/g, "&amp;");
            if (content.replace(/<br>/g, "").replace(/\W/g, "") === "") {
                this.$message.error("请填写回复内容！");
                return;
            }
            this.posting = true;

            const { data } = await axios
                .post("/backend/bbs/appendPost.php", createFormData({
                    tid: this.thread.id, content, client: 'web'
                }));
            this.posting = false;
            if (data.code == 0) {
                this.$message.success('发布成功');
                window.location.reload();
            } else {
                const reason = getReason(data.code, {
                    '-1': '字数超限',
                });
                this.$message.error(`发布失败: ${ reason }`);
            }
        },
        openEditDialog(post) {
            this.editPost = post;
            if (this.$refs.edit) {
                this.$refs.edit.setValue(post.content);
            } else {
                this.editData = post.content;
            }
            this.editorVisible = true;
        },
        async doEdit() {
            this.editing = true;
            const { data } = await axios.post("/backend/bbs/editPost.php", createFormData({
                tid: this.thread.id,
                pid: this.editPost.id,
                content: this.editData,
            }));
            this.editing = false;
            if (data.code == 0) {
                this.editorVisible = false;
                this.$message.success('修改成功');
                window.location.reload();
            } else {
                const reason = getReason(data.code, {
                    '-1': '字数超限',
                });
                this.$message.error(`修改失败 ${ reason }`);
            }
        },
        async manageThread(key) {
            const item = this.manageItems.find(e => e.key == key);
            const currentValue = this.thread[key];
            const reason = prompt(`确认要对本贴进行[${ item.text[currentValue] }]操作吗？\n你正在动用管理权限，请给出操作理由`, '');
            if (reason === null) return;
            const value = currentValue ^ 1;
            const { data } = await axios
                .post("/backend/bbs/manageThread.php", createFormData({
                    tid: this.thread.id, key, value, reason
                }));
            if (data.code == 0) {
                this.$message.success('修改成功');
                window.location.reload();
            } else {
                this.$message.error('修改失败');
                //
            }
        }
    },
    components: {
        MainHeader, Footer, UserLink, Post, WangEditor,
    }
}
</script>

<style lang="less">
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
.adjuster {
    margin: 20px auto;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
}
.thread-title {
    display: flex;
    align-items: center;
    .ant-tag {
        margin-left: 5px;
    }
}
#editor {
    margin-top: 20px;
    text-align: left;
}
#reply {
    margin-left: 15px;
}
.ant-pagination.top-pager {
    margin-top: 10px;
    margin-bottom: -10px;
}
</style>

